<section class="section featured-jobs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="title mb-4">
          <h1>Featured Jobs</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="tab-content">
          <div>
            <div class="row mb-5">
              <div class="col-lg-12">
                <app-shared-job-loading *ngIf="isLoading"></app-shared-job-loading>
                <!-- JOB BOX STARTS-->
                <a class="pointer" routerLink="/overview/{{ job.jobId }}" *ngFor="let job of jobs">
                  <div class="job-box bg-white mt-4">
                    <div class="p-4">
                      <div class="row gray">
                        <div class="col-xl-9">
                          <div>
                            <h5>
                              <a routerLink="/overview/{{ job.jobId }}" class="gray">{{
                                job.title
                              }}</a>
                              <app-shared-display-badge [division]="job.division">
                              </app-shared-display-badge>
                            </h5>
                            <div class="mb-0" [innerHTML]="job.description | shortNote"></div>
                          </div>
                        </div>
                        <div class="col-xl-3 details gray">
                          <app-shared-job-properties [job]="job"></app-shared-job-properties>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 text-center">
        <button class="submitBnt searchBtn btn btn-custom" (click)="moreJobs()">
          Browse More Job Openings
        </button>
      </div>
    </div>
  </div>
</section>
